import { makeStyles } from '@mui/styles'

export default makeStyles({
  moon: {
    '&&': {
      height: 'initial',
      marginRight: '0',
      width: 'initial',
      maxWidth: '100%',
    },
  },
})
